import { FETCH_SHIPPING_FAILURE, FETCH_SHIPPING_REQUEST, FETCH_SHIPPING_SUCCESS } from "../actions/shipingAction";


const initialState = {
    loading: false,
    shippingChargesList: null,
    error: null,
};

const shippingReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_SHIPPING_REQUEST:
            return { ...state, loading: true, error: null };
        case FETCH_SHIPPING_SUCCESS:
            return { ...state, loading: false, shippingChargesList: action.payload };
        case FETCH_SHIPPING_FAILURE:
            return { ...state, loading: false, error: action.payload, shippingChargesList: [] };
        default:
            return state;
    }
};

export default shippingReducer;
